<script lang="ts" setup>

import { ref, computed, watch } from 'vue'

import TextInput from '@form/TextInput.vue'
const password = defineModel('password')
const passwordConfirmation = defineModel('passwordConfirmation')

const props = defineProps({
    labelClasses: {},
    errors: {},
    oldInputConfirmPassword: {}
})

const emit = defineEmits([
    'update:password',
    'update:password-confirmation'
])

const localPassword = ref(null)
watch(() => localPassword, (newVal) => {
    emit('update:password', newVal)
})

const localPasswordConfirmation = ref(null)
watch(() => localPasswordConfirmation, (newVal) => {
    emit('update:passwordConfirmation', newVal)
})
const passwordIsHidden = ref(true)

const passwordStrength = computed(() => {
    let strength = 0;

    if (!! password.value) {
        [
            /[A-Za-z]/,
            /[0-9]/,
            /[^A-Za-z0-9]/,
        ].forEach(expression => {
            if (password.value.match(expression))
                strength++;
        })

        if (password.value.length >= 10)
            strength++;
    }

    return strength
})

const passwordStrengthBarClasses = computed(() => {
    if (passwordStrength.value <= 2) {
        return 'progress-bar-danger w-1/3'
    }
    if (passwordStrength.value == 3) {
        return 'progress-bar-warning w-2/3'
    }
    if (passwordStrength.value == 4) {
        return 'progress-bar-success w-full'
    }
})

const passwordStrengthText = computed(() => {
    if (passwordStrength.value <= 2) {
        return 'Weak'
    }
    if (passwordStrength.value == 3) {
        return 'Average'
    }
    if (passwordStrength.value == 4) {
        return 'Strong'
    }
})

</script>

<template>
    <div>
        <!--New Password-->
        <div class="relative">
            <div class="relative">
                <TextInput
                    name="password"
                    :labelClasses="props.labelClasses"
                    :type="passwordIsHidden ? 'password' : 'text'"
                    v-model="localPassword"
                    @update="emit('update:password', $event.target.value)"
                    autocomplete="new-password"
                    class="w-full"
                >New Password</TextInput>
                <fa-icon
                    :icon="{
                        'fa-solid fa-eye': !! passwordIsHidden,
                        'fa-solid fa-eye-slash': ! passwordIsHidden,
                    }"
                    :class="{
                        'text-red-500': ! passwordIsHidden
                    }"
                    icon="fa-solid fa-eye"
                    class="absolute text-ll-black pt-3 cursor-pointer"
                    style="right: 0.5rem; top:1.5rem;"
                    @click.stop="passwordIsHidden = ! passwordIsHidden"
                />
            </div>

            <div class="progress">
                <div
                    id="password-strength"
                    class="progress-bar"
                    :class="passwordStrengthBarClasses"
                    role="progressbar"
                    aria-valuenow="40"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width:0%"
                ></div>
            </div>

            <p class="text-xs ml-2 mt-2 text-right font-semibold">
                Password Strength: <span id="strengthText">{{ passwordStrengthText }}</span>
            </p>
        </div>

        <!--Confirm New Password-->
        <div class="relative">
            <div class="relative">
                <TextInput
                    :labelClasses="props.labelClasses"
                    type="password"
                    name="password_confirmation"
                    v-model="localPasswordConfirmation"
                    @update="emit('update:password-confirmation', $event.target.value)"
                    id="password_confirmation"
                    autocomplete="new-password"
                    class="w-full"
                >Confirm New Password </TextInput>
                <i
                    class="absolute text-ll-black pt-3 fa-solid fa-eye cursor-pointer"
                    style="right: 0.5rem; top:1.5rem;"
                ></i>
            </div>
        </div>
    </div>
</template>
